import React, { useContext } from "react";
import PropTypes from "prop-types";
import LoadingOverlay from "react-loading-overlay";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import SaveIcon from "@mui/icons-material/Save";
// import GitInfo from 'react-git-info/macro'
import UserContext from "../context/userContext";
import adminConfigService from "../../services/api/adminConfigService";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      style={{
        height: "100%",
        display: value === index ? "flex" : "none",
        flexDirection: "column",
      }}
      {...other}
    >
      {value === index && <Box style={{ height: "100%", overflow: "auto" }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  header: {
    marginBottom: theme.spacing(3),
  },
  environmentControl: {
    minWidth: 200,
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    height: "100%",
    minHeight: "calc(100vh - 220px)",
    "& .MuiTabs-flexContainer": {
      height: "100%",
    },
  },
  tabPanel: {
    padding: 0,
    height: "100%",
  },
  card: {
    height: "calc(100vh - 220px)",
    margin: 0,
    display: "flex",
    flexDirection: "column"
  },
  cardContent: {
    padding: theme.spacing(2),
    height: "100%",
    overflowY: "auto",
    flex: 1,
  },
  fieldRow: {
    alignItems: "center",
  },
  gridContent: {
    width: "100%",
    alignItems: "center",
  },
  saveButton: {
    marginLeft: theme.spacing(2),
  },
  alertroot: {
    marginBottom: theme.spacing(2),
    "& > * + *": {
      marginTop: theme.spacing(1),
    },
  },
  disabled: {
    opacity: 0.6,
    pointerEvents: "none",
  },
  containerWrapper: {
    height: "calc(100vh - 220px)",
    display: "flex",
    gap: theme.spacing(2),
  },
  tabsContainer: {
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden",
    paddingRight: 0,
  },
  contentContainer: {
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden",
    flex: 1,
    paddingRight: 0,
    display: "flex",
    flexDirection: "column",
  },
  loadingOverlayWrapper: {
    height: "100%",
    maxHeight: "100%",
    display: "flex",
    flexDirection: "column",
  },
}));

export default function AdminConfig() {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [value, setValue] = React.useState(0);
  const [environments, setEnvironments] = React.useState([]);
  const [environment, setEnvironment] = React.useState("");
  const [environmentCopy, setEnvironmentCopy] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [pageLoading, setPageLoading] = React.useState(true);
  const { board, setBoard } = useContext(UserContext);
  const [configData, setConfigData] = React.useState(null);
  const [successAlert, setsuccessAlert] = React.useState(false);
  const [errorAlert, seterrorAlert] = React.useState(false);
  const [bannerData, setBannerData] = React.useState(null);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 4 && !bannerData) {
      getBannerdata();
    }
  };

  const getBannerdata = () => {
    adminConfigService.getBannerData().then((response) => {
      setBannerData(response.data[0]);
      setLoading(false);
    });
  };

  function updateBannerData() {
    setLoading(true);
    adminConfigService.updateBannerData(bannerData).then(
      (response) => {
        setLoading(false);
        setsuccessAlert(true);
        setBoard({
          ...board,
          bannerData,
        });
        setTimeout(() => {
          setsuccessAlert(false);
        }, 20000);
      },
      (error) => {
        if (error) {
          setLoading(false);
          seterrorAlert(true);
        }
      }
    );
  }

  const setBanner = (e) => {
    if (e.target.name === "visibility") {
      setBannerData({
        ...bannerData,
        [e.target.name]: e.target.checked,
      });
    } else {
      setBannerData({
        ...bannerData,
        [e.target.name]: e.target.value,
      });
    }
  };

  function getConfig(value) {
    setLoading(true);
    adminConfigService.adminconfig(value).then((configresponse) => {
      setLoading(false);
      if (value === "") {
        setEnvironment(configresponse.data.environment);
        setEnvironmentCopy(configresponse.data.environment);
      }
      const data = configresponse.data.configparams;
      setConfigData(data);
    });
  }

  const changeEnv = (e) => {
    setEnvironment(e.target.value);
    getConfig(e.target.value);
  };

  const switchToggle = (type, e) => {
    const configdata1 = configData;
    const subtype = configdata1[type];
    subtype[e.target.name] = e.target.checked;
    configdata1[type] = subtype;
    setConfigData({
      ...configdata1,
    });
  };

  const handleChange = (type, e, child) => {
    const configdata1 = configData;
    const subtype = configdata1[type];
    if (child) {
      subtype[child][e.target.name] = e.target.value;
    } else {
      subtype[e.target.name] = e.target.value;
    }
    configdata1[type] = subtype;
    setConfigData({
      ...configdata1,
    });
  };

  React.useEffect(() => {
    getBannerdata();
    setBoard({
      ...board,
      currentState: "/adminconfig",
    });

    adminConfigService.getAllEnvironment("").then((response) => {
      setEnvironments(response.data);
      getConfig("");
      setPageLoading(false);
    });
  }, []);

  const saveConfig = () => {
    if (value === 3) {
      updateBannerData();
    } else {
      setLoading(true);
      adminConfigService.saveAdminConfig(environment, configData).then(
        (response) => {
          setLoading(false);
          setsuccessAlert(true);
          setTimeout(() => {
            setsuccessAlert(false);
          }, 20000);
        },
        (error) => {
          if (error) {
            setLoading(false);
            seterrorAlert(true);
          }
        }
      );
    }
  };

  return (
    <LoadingOverlay active={pageLoading} spinner text="Loading Admin Configuration...">
      <Box className={classes.root}>
        {/* Alerts */}
        <Grid container spacing={2} className={classes.alertroot}>
          {successAlert && (
            <Grid item xs={12}>
              <Alert severity="success">Admin Configuration Saved Successfully</Alert>
            </Grid>
          )}
          {errorAlert && (
            <Grid item xs={12}>
              <Alert severity="error" onClose={() => seterrorAlert(false)}>
                Something went wrong. Contact system administrator!
              </Alert>
            </Grid>
          )}
        </Grid>

        {/* Header with Environment and Save Button */}
        <Grid container spacing={2} className={classes.header} alignItems="center">
          <Grid item xs={12} sm={8}>
            <Typography variant="h6" style={{ fontWeight: 600 }}>
              Admin Configuration
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Environment</InputLabel>
              <Select
                value={environment}
                onChange={changeEnv}
                label="Environment"
                className={classes.environmentControl}
              >
                {environments.map((value) => (
                  <MenuItem value={value.environment} key={value.environment}>
                    {value.environment}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              disabled={loading || environment !== environmentCopy}
              onClick={() => saveConfig()}
              startIcon={<SaveIcon />}
            >
              Save
            </Button>
          </Grid>
        </Grid>

        {/* Tabs and Content */}
        <Box className={classes.containerWrapper}>
          {/* Tabs Container */}
          <Box className={classes.tabsContainer} style={{ width: "200px", minWidth: "200px" }}>
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={value}
              onChange={handleTabChange}
              className={classes.tabs}
              TabIndicatorProps={{
                style: { background: "#1976d2", width: 4 },
              }}
              scrollButtons="auto"
            >
              <Tab label="Settings" />
              <Tab label="Crowd DB" />
              <Tab label="IDMS" />
              <Tab label="Banner" />
              <Tab label="Iris" />
            </Tabs>
          </Box>

          {/* Content Container */}
          <Box className={classes.contentContainer}>
            {/* Settings Tab */}
            <TabPanel value={value} index={0}>
              <Box className={classes.loadingOverlayWrapper}>
                <LoadingOverlay active={loading} spinner text="loading">
                  {configData && (
                    <Card className={classes.card} variant="outlined">
                      <CardContent className={classes.cardContent}>
                        <Grid
                          container
                          spacing={2}
                          className={`${classes.gridContent} ${environment !== environmentCopy ? classes.disabled : ""
                            }`}
                        >
                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Admin Group</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" name="adminADGroup" onChange={(e) => handleChange("admin", e)} value={configData.admin.adminADGroup} />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Session Timeout (mins)</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" onChange={(e) => handleChange("settings", e)} name="session_timeout" value={configData.settings.session_timeout} type="number" />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Email Notification</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <Switch onChange={(e) => switchToggle("settings", e)} name="email_notification" checked={configData.settings.email_notification} />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Debug Logger</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <Switch onChange={(e) => switchToggle("logger", e)} name="debug" checked={configData.logger.debug} />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Console Logger</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <Switch onChange={(e) => switchToggle("logger", e)} name="console" checked={configData.logger.console} />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Attachment File Size (MB)</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" onChange={(e) => handleChange("settings", e)} name="attachment_size" value={configData.settings.attachment_size} type="number" />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Help Page URL</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" name="help_page" onChange={(e) => handleChange("settings", e)} value={configData.settings.help_page} />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Own Hostname</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" name="own_hostname" onChange={(e) => handleChange("settings", e)} value={configData.settings.own_hostname} />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Own URL</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" name="own_url" onChange={(e) => handleChange("settings", e)} value={configData.settings.own_url} />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Profile Picture Size (Bytes)</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" name="profile_picture_size" onChange={(e) => handleChange("settings", e)} value={configData.settings.profile_picture_size} />
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  )}
                </LoadingOverlay>
              </Box>
            </TabPanel>
            {/* Crowd DB Tab */}
            <TabPanel value={value} index={1}>
              <Box className={classes.loadingOverlayWrapper}>
                <LoadingOverlay active={loading} spinner text="loading">
                  {configData && (
                    <Card className={classes.card} variant="outlined">
                      <CardContent className={classes.cardContent}>
                        <Grid container spacing={2} className={`${classes.gridContent} ${environment !== environmentCopy ? classes.disabled : ""
                          }`}>
                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>App Name</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" onChange={(e) => handleChange("Crowd", e)} name="appName" value={configData.Crowd.appName} />
                          </Grid>
                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Host Name</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" onChange={(e) => handleChange("Crowd", e)} name="hostName" value={configData.Crowd.hostName} />
                          </Grid>
                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Host</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" onChange={(e) => handleChange("crowdDBConfig", e)} name="host" value={configData.crowdDBConfig.host} />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Port</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" onChange={(e) => handleChange("crowdDBConfig", e)} name="port" value={configData.crowdDBConfig.port} />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>DB Name</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" onChange={(e) => handleChange("crowdDBConfig", e)} name="dbName" value={configData.crowdDBConfig.dbName} />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Username</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" onChange={(e) => handleChange("crowdDBConfig", e)} name="userName" value={configData.crowdDBConfig.userName} />
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  )}
                </LoadingOverlay>
              </Box>
            </TabPanel>

            {/* IDMS Tab */}
            <TabPanel value={value} index={2}>
              <Box className={classes.loadingOverlayWrapper}>
                <LoadingOverlay active={loading} spinner text="loading">
                  {configData && (
                    <Card className={classes.card} variant="outlined">
                      <CardContent className={classes.cardContent}>
                        <Grid container spacing={2} className={`${classes.gridContent} ${environment !== environmentCopy ? classes.disabled : ""
                          }`}>
                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>URL</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" onChange={(e) => handleChange("idms", e)} name="url" value={configData.idms.url} />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Username</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" onChange={(e) => handleChange("idms", e)} name="userName" value={configData.idms.userName} />
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  )}
                </LoadingOverlay>
              </Box>
            </TabPanel>

            {/* Banner Tab */}
            <TabPanel value={value} index={3}>
              <Box className={classes.loadingOverlayWrapper}>
                <LoadingOverlay active={loading} spinner text="loading">
                  {bannerData && (
                    <Card className={classes.card}>
                      <CardContent className={classes.cardContent}>
                        <Grid container spacing={2} className={`${classes.gridContent} ${environment !== environmentCopy ? classes.disabled : ""
                          }`} alignItems="center">
                          <Grid item xs={12}>
                            <Typography>Message</Typography>
                          </Grid>
                          <Grid item xs={12} sx={{ pt: '0.5px !important' }}>
                            <TextField fullWidth multiline rows={6} name="message" onChange={(e) => setBanner(e)} value={bannerData.message} />
                          </Grid>

                          <Grid item className={classes.fieldRow}>
                            <Typography>Visibility</Typography>
                          </Grid>
                          <Grid item>
                            <Switch onChange={(e) => setBanner(e)} name="visibility" checked={bannerData.visibility} />
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  )}
                </LoadingOverlay>
              </Box>
            </TabPanel>

            {/* Iris Tab */}
            <TabPanel value={value} index={4}>
              <Box className={classes.loadingOverlayWrapper}>
                <LoadingOverlay active={loading} spinner text="loading">
                  {configData && (
                    <Card className={classes.card} variant="outlined">
                      <CardContent className={classes.cardContent}>
                        <Grid container spacing={2} className={`${classes.gridContent} ${environment !== environmentCopy ? classes.disabled : ""
                          }`}>
                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>IRIS Ticket URL</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" onChange={(e) => handleChange("iris", e)} name="uri" value={configData.iris.uri} />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>IRIS Header URL</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" onChange={(e) => handleChange("iris", e)} name="iris_header_url" value={configData.iris.iris_header_url} />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Token Validation URL</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" onChange={(e) => handleChange("iris", e)} name="iris_token_url" value={configData.iris.iris_token_url} />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Resource</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" onChange={(e) => handleChange("iris", e)} name="resource" value={configData.iris.resource} />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Client ID</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" onChange={(e) => handleChange("iris", e)} name="client_id" value={configData.iris.client_id} />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Grant Type</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" onChange={(e) => handleChange("iris", e)} name="grant_type" value={configData.iris.grant_type} />
                          </Grid>

                          <Grid item xs={12} md={4} className={classes.fieldRow}>
                            <Typography>Configuration Item</Typography>
                          </Grid>
                          <Grid item xs={12} md={8}>
                            <TextField fullWidth size="small" onChange={(e) => handleChange("iris", e)} name="configuration_item" value={configData.iris.configuration_item} />
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  )}
                </LoadingOverlay>
              </Box>
            </TabPanel>
          </Box>
        </Box>
      </Box>
    </LoadingOverlay>
  );
}
